<template>
<div>

<ContentHeader  v-if="$store.state.questions.question"  :title="$store.state.languages.lang_phrases.soru+' '+$store.state.languages.lang_phrases.sinif_faktorleri"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<div class="grid" v-for="item in items" v-show="item.inputfieldclass">
<div class="col-11 md:col-11">
<ClickEditSlider  :title="item.inputfieldclass.name" :value="item.factor" :steps="1" :valkey="item.id" @dataChanged="dataChanged"  :min="0" :max="100"/>

</div>

<div class="col-1 md:col-1">

<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteItem('inputfieldclassfactor',item.id)"></Button>
</div>
</div>

<ClickAddSelect  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="qulist_id" @newAdded="newAdded" :options="classes"></ClickAddSelect>

</div>
</template>


</div>
</template>

<script>
export default {

  name: 'QuestionClassIndices',

  data () {
    return {
    	loading:true,
      classes:[],
      items:[],
    }
  },
  mounted()
  {
    this.getData()
  },
  computed:{
    headerurlparams()
    {
      return {id:this.$store.state.questions.question.questionlist_id}
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  methods:{
    dataChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append("factor",data.value) 
      this.generalSubmission(formdata,"inputfieldclassfactor/"+data.key,this.afternewAdded)
    },
    async getData()
    {
        this.loading = await true
        this.classes = await this.generalApiGetWithoutLoader("inputfield_factored_classes/"+this.$route.params.id)
        this.items = await this.generalApiGetWithoutLoader("inputfieldclassfactors/"+this.$route.params.id)          
        this.loading = await false
        console.log(this.classes)
        console.log(this.items)

    }, 
    newAdded(data)
    {
      console.log(data);
      let formdata = new FormData()
      formdata.append("inputfieldclass_id",data.value)    
      this.generalSubmission(formdata,"newinputfieldclassfactor/"+this.$route.params.id,this.afternewAdded)
    },
    afternewAdded(response)
    {
      console.log(response.data)
      this.getData()
    },
  }
}
</script>

<style lang="css" scoped>
</style>